module.exports = __webpack_public_path__ + "static/media/W77F1013.ee90775f.svg";